import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import {AdditionalRight} from '../interfaces/additionalRight';
import {UiSettingsService} from '../../shared/ui-settings.service';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class AdditionalRightService extends GeneralService<AdditionalRight> {

  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'additionalrights', 'additionalright');
  }
}
